import useTypedTranslation from "@/core/hooks/use-typed-translation";
import React from "react";
import { Button } from "@/core/components/ui/buttonStyled/button";
import { TableCell, TableRow } from "@/core/components/ui/table";
import { apiErrorHandler } from "@/core/api/api-error-handler";

interface ErrorTableProps {
  error?: {
    message: string;
    refetch?: () => void;
  };
}

export const ErrorTable: React.FC<ErrorTableProps> = ({ error }) => {
  const { t } = useTypedTranslation();
  const displayMessage = error?.message
    ? apiErrorHandler({ message: error.message })
    : t("tableErrorText");

  return (
    <TableRow>
      <TableCell colSpan={100}>
        <div className="flex flex-col items-center justify-center gap-2 px-4 py-12 sm:px-8 sm:py-24">
          <p className="max-w-md text-center text-base font-medium text-destructive">
            {displayMessage || t("tableErrorText")}
          </p>
          {error?.refetch && (
            <Button
              className="mt-2"
              onClick={error?.refetch}
              variant="secondary"
              size="sm"
            >
              {t("reload")}
            </Button>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};
